import { JsonObject } from '../../helpers';
import { ConnectorFeatureSet } from './';
import { ConnectorModel } from './connector.model';

export type DohConfig = {
  serviceUrl?: string;
  catalogUrl?: string;
};

export class DohConnectorModel extends ConnectorModel {
  config: DohConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'doh';
    this.typeLabel = 'DNS over HTTPS';
    this.icon = 'doh';

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: false,
      contextData: false,
      ingress: true,
    };

    this.config = (data.config as DohConfig) || {};

    this.highlander = true;
  }
}
